<template>
  <div class="text-center">
    <img
      :src="require('@/assets/images/no-data/' + img)"
      alt="no data icon"
      class="d-inline-block"
    />
    <div class="pGrey--text my-10">{{ text }}</div>
    <v-btn
      v-if="!hideBtn"
      class="p-btn-rounded"
      color="primary"
      large
      rounded
      dark
      @click="$emit('btn-click')"
    >
      {{ btnText || $t('add') }}
    </v-btn>
  </div>
</template>


<script>
export default {
  inheritAttrs: false,


  props: {
    img: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    hideBtn: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: String,
      required: false
    }
  }
}
</script>
